<template>
  <div class="row">
    <div class="col-lg-12">
      <StatusModal :show.sync="modals.successModal" :message="modal.success" :title="modal.successTitle" />

      <!-- <modal :show.sync="modals.submit" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <img src="@/assets/img/tick.png" width="300" />
            <br />
            <br />
            <br />
            <h1>JOB REQUEST SUCCESSFULLY SUBMITTED</h1>
            <p>
              Our Customer Relations Officer will be in touch with you within 24
              hours
            </p>
          </div>
        </div>
      </modal> -->

      <modal :show.sync="modals.warningsubmit" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">Please fill in all the forms.</div>
        </div>
      </modal>
      <modal :show.sync="modals.generate" class="modal-eprf" centered>
        <div class="row">
          <div class="col-lg text-center">
            <div class="row">
              <div class="col-lg">
                <img src="@/assets/img/tick.png" width="300" />
              </div>
            </div>
            <br />
            <br />
            <br />
            <div class="row">
              <div class="col-lg">
                <h1>{{ title }}</h1>
              </div>
            </div>

            <div class="row">
              <div class="col-lg">
                <p>
                  {{ message }}
                </p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg">
                <base-button class="btn-primary" @click="nextWithCondition()">Done</base-button>
              </div>
            </div>
          </div>
        </div>
      </modal>
      <!-- no need to separate add and edit because small difference -->

      <div class="row">
        <div class="col-lg-4 d-flex">
          <card class="card-eprf">
            <p style="color: #358CCB; font-size: 24px; font-weight: 300">
              JOB DETAILS
            </p>
            <div style="height: 490px; overflow: auto; overflow-x: hidden">
              <p class="new-title">
                Pickup Location
                <span v-if="displayflag" style="color: #EC1B23">*</span>
              </p>
              <p class="subtitle" v-if="!displayflag">
                {{ locationname }}
              </p>
              <el-select v-if="displayflag" class="select-info tab select-width" popper-class="custom-dropdown"
                placeholder="Select" v-model="selects.location" style="width: 90%; border-bottom: 1px solid lightgray">
                <el-option v-for="option in selects.locations" class="select-info custom-option" :value="option.value"
                  :label="option.label" :key="option.value"></el-option>
              </el-select>

              <p class="new-title">
                PIC Full Name
                <span v-if="displayflag" style="color: #EC1B23">*</span>
              </p>
              <p class="subtitle" v-if="!displayflag">
                {{ picname }}
              </p>
              <el-select v-if="displayflag" class="select-info tab select-width" popper-class="custom-dropdown"
                placeholder="Select" v-model="selects.pic" style="width: 90%; border-bottom: 1px solid lightgray">
                <el-option v-for="option in selects.pics" class="select-info custom-option" :value="option.value"
                  :label="option.label" :key="option.value"></el-option>
              </el-select>

              <p class="new-title">PIC Phone No.</p>
              <p class="subtitle">
                {{ phoneno }}
              </p>

              <p class="new-title">PIC Fax No.</p>
              <p class="subtitle">
                {{ faxno }}
              </p>

              <p class="new-title">PIC Email</p>
              <p class="subtitle">
                {{ email }}
              </p>
            </div>
          </card>
        </div>
        <!-- waste details -->
        <div class="col-lg-8 d-flex">
          <card class="card-eprf">
            <div class="row" style="display: flex">
              <div class="col-lg">
                <p style="color: #358CCB; font-size: 24px; font-weight: 300">
                  WASTE DETAILS
                </p>
              </div>
            </div>

            <div id="tableku" v-if="displayflag" style="height: 500px; overflow: auto; overflow-x: hidden">
              <div class="row">
                <div class="col-lg">
                  <el-table :data="tableDatas" :header-cell-style="{
                    background: '#358DCC',
                    border: 'transparent',
                    'font-size': '14px',
                    'font-weight': '400',
                    color: '#FFFFFF',
                  }">
                    <el-table-column label="NO." width="50" align="center">
                      <div slot-scope="scope">
                        <p style="color: #707070">
                          {{ scope.$index }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="180" align="center" prop="wastetype" label="WASTE TYPE">
                      <div slot-scope="scope">
                        <div class="row">
                          <!-- <div class="col-lg"> -->
                          <div style="position: relative">
                            <span style="
                                color: #EC1B23;
                                position: absolute;
                                bottom: 17%;
                                right: 0;
                              ">*</span>
                            <el-select class="select-info tab select-width" popper-class="custom-dropdown"
                              placeholder="Select SW code" v-model="scope.row.swcode">
                              <el-option v-for="option in selects.wastetypes" class="select-info custom-option"
                                :value="option.value" :label="option.label" :key="option.value" style="
                                  width: 300px;
                                  height: auto;
                                  white-space: normal;
                                "></el-option>
                            </el-select>
                          </div>
                        </div>
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="130" align="center" prop="wasteComponents" label="WASTE COMPONENT">
                      <div slot-scope="scope">
                        <div class="row" v-for="(item, index) in scope.row.wasteComponents" :key="index">
                          <div class="col-lg-9 text-right">
                            <input type="text" v-model="item.name" :class="{ 'custom-input': true }" />
                          </div>
                          <div class="col-lg-3 text-left" style="padding-top: 3%; right: 30px">
                            <base-button class="btn-cancel btn-link" @click="deletecomponent(scope.$index, index)"><i
                                class="tim-icons icon-simple-remove"></i></base-button>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-lg">
                            <p @click="addWasteComponent(scope.$index)" style="color: #358CCB; cursor: pointer"
                              class="link">
                              + Add
                            </p>
                          </div>
                        </div>
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="250" align="center" prop="estqty" label="QTY.">
                      <div slot-scope="{ row }">
                        <div align="center">
                          <div class="row">
                            <div class="col-lg-3">
                              <div style="width: 100%" align="left">
                                <input type="number" v-model="row.estqty" :class="{ 'custom-input': true }" step="0.01"
                                  min="0.00" />
                              </div>
                            </div>
                            <div class="col-lg text-left">
                              <p style="
                                  color: #A5A5A5;
                                  position: absolute;
                                  left: 20px;
                                ">
                                {{ row.measurement }}
                                <span style="
                                    color: #EC1B23;

                                    bottom: 17%;
                                    right: 0;
                                  ">*
                                </span>
                              </p>
                              <!-- <div style="position: relative"> -->

                              <!-- <el-select
                                    v-if="row.nickname != 'tyre'"
                                    class="select-info tab select-width"
                                    placeholder="Select unit"
                                    v-model="row.measurement"
                                    style="width: 100%"
                                  >
                                    <el-option
                                      v-for="option in selects.measurements"
                                      class="select-info custom-option"
                                      :value="option.value"
                                      :label="option.label"
                                      :key="option.value"
                                    ></el-option>
                                  </el-select> -->

                              <!-- </div> -->
                            </div>
                          </div>

                          <div class="row">
                            <div class="col-lg-3">
                              <div style="width: 100%" align="left">
                                <input type="number" min="0" v-model="row.estqtyy" :class="{ 'custom-input': true }" />
                              </div>
                            </div>
                            <div class="col-lg text-left">
                              <div class="row">
                                <div style="position: relative">
                                  <span style="
                                      color: #EC1B23;
                                      position: absolute;
                                      bottom: 17%;
                                      right: 0;
                                    ">*</span>

                                  <el-select class="select-info tab select-width" popper-class="custom-dropdown"
                                    placeholder="Select packaging type" v-model="row.packaging" style=""
                                    @change="getType2(row)">
                                    <el-option v-for="option in selects.packagings" class="select-info custom-option"
                                      :value="option.value" :label="option.label" :key="option.value"></el-option>
                                  </el-select>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-table-column>

                    <el-table-column :min-width="100" align="center" prop="remarks" label="REMARKS">
                      <div slot-scope="{ row }">
                        <input type="text" v-model="row.remarks" :class="{ 'custom-input': true }" />
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="40" align="center" label="SELL">
                      <div slot-scope="{ row }">
                        <el-checkbox label="" v-model="row.action"></el-checkbox>
                      </div>
                    </el-table-column>
                    <el-table-column width="50" align="center" prop="delete" label="">
                      <div slot-scope="scope">
                        <i v-if="scope.$index != 0 && displayflag" style="
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            color: #ff0000;
                            font-size: 15px;
                            font-weight: 900;
                            cursor: pointer;
                          " @click="getDeleteRow(scope.$index)" class="tim-icons icon-trash-simple"></i>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div id="tableku" v-if="!displayflag" style="height: 500px; overflow: auto; overflow-x: hidden">
              <div class="row">
                <div class="col-lg">
                  <el-table :data="tableDatas" :header-cell-style="{
                    background: '#358DCC',
                    border: 'transparent',
                    'font-size': '14px',
                    'font-weight': '400',
                    color: '#FFFFFF',
                  }">
                    <el-table-column label="NO." width="50" align="center">
                      <div slot-scope="scope">
                        <p style="color: #707070">
                          {{ scope.$index + 1 }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="300" align="center" prop="swcodename" label="WASTE TYPE">
                      <div slot-scope="{ row }">
                        <p class="swcode-text">
                          {{ row.swcodename }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="150" align="center" prop="wasteComponents" label="WASTE COMPONENT">
                      <div slot-scope="{ row }">
                        <p class="swcode-text" v-for="(item, index) in row.wasteComponents" :key="index">
                          {{ index + 1 }}. {{ item }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="150" align="center" prop="estqty" label="EST. QTY.">
                      <div slot-scope="{ row }">
                        <div align="center">
                          <div class="row">
                            <div class="col-lg">
                              <p class="swcode-text">
                                {{ row.estqty }} {{ row.estqtyy }}
                              </p>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg">
                              <p class="swcode-text">
                                {{ row.packaging_quantity }} {{ row.packaging }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-table-column>
                    <el-table-column :min-width="120" align="center" prop="remarks" label="REMARKS">
                      <div slot-scope="{ row }">
                        <p class="swcode-text">
                          {{ row.remarks }}
                        </p>
                      </div>
                    </el-table-column>
                    <el-table-column width="50" align="center" prop="delete" label="">
                      <div slot-scope="scope">
                        <i v-if="scope.$index != 0 && displayflag" style="
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            transform: translate(-50%, -50%);
                            color: #ff0000;
                            font-size: 15px;
                            font-weight: 900;
                            cursor: pointer;
                          " @click="getDeleteRow(scope.$index)" class="tim-icons icon-trash-simple"></i>
                      </div>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
            <div class="row text-right" v-if="displayflag">
              <div class="col-lg" v-if="wastetype != 'noshow'">
                <p @click="addRow()" style="color: #358CCB; cursor: pointer" class="link">
                  + Add row
                </p>
              </div>
            </div>
          </card>
        </div>
      </div>

      <div class="row">
        <div class="col-lg text-right">
          <base-button type="danger" v-on:click="prevTab()">Back</base-button>&nbsp;
          <base-button v-if="displayflag" type="primary" :disabled="!canproceed"
            v-on:click="submitwastedetail()">Submit</base-button>
          <base-button v-if="!displayflag" type="primary" v-on:click="nextTab()">Next</base-button>
        </div>
      </div>
      <div class="row">
        <div class="col-lg text-right">
          <p style="color: #EC1B23">{{ errmsg }}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-lg"></div>
        <div v-if="warning == true" class="col-lg-3 text-right">
          <p style="color: #ff0000; font-size: 12px">
            {{ otherswarning }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Checkbox, Table, TableColumn, Option, Select, DatePicker } from "element-ui";
import { ImageUpload, Modal } from "src/components";
import { Circle8 } from "vue-loading-spinner";
import { debounce } from "src/util/debounce";
import swal from "sweetalert2";
import moment from "moment";
import { getStorage } from "../../../../../util/storage";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { BCard } from "bootstrap-vue";
import StatusModal from "src/components/StatusModal.vue";
import { modal } from "src/components/variable.js";

export default {
  // props: ["parentData"],
  components: {
    StatusModal,
    ImageUpload,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Checkbox.name]: Checkbox,
    Circle8,
    Modal,
    BCard,
  },

  data() {
    return {
      title: "",
      message: "",
      errmsg: "",
      otheropen: false,
      quoopen: false,
      imgmsg: "",
      modal: modal,
      docs: "",
      picsubmitted: "",
      imageurl: [],
      phoneno: "",
      wastecomp: "",
      wastetype: "",
      displayflag: false,
      locationname: "",
      picname: "",
      status: "",

      warning: false,

      email: "",
      faxno: "",

      load: false,

      selects: {
        location: "",
        locations: [
          // { value: 1, label: "Workshop Asia Port, CT1" },
          // { value: 2, label: "Workshop Asia Port, CT1" },
          // { value: 3, label: "Others (Please specify)" },
        ],

        pic: "",
        pics: [
          // { value: 1, label: "Amirah binti Azman" },
          // { value: 2, label: "Yahya Abd Rahman" },
          // { value: 3, label: "Haziq Haikal bin Ayub" },
        ],

        wastetype: "",
        wastetypes: [
          // { value: 1, label: "Scheduled Waste" },
          // { value: 2, label: "Garbage" },
          // { value: 3, label: "Sewage" },
          // { value: 4, label: "Scrap" },
          // { value: 5, label: "Others" },
        ],

        // swcode: "",
        // swcodes: [
        // { value: 1, label: "SW101" },
        // { value: 2, label: "SW102" },
        // { value: 3, label: "SW103" },
        // { value: 4, label: "SW104" },
        // { value: 5, label: "SW105" },
        // ],

        measurement: "kg",
        measurements: [
          { value: "kg", label: "kg" },
          // { value: "M³", label: "M³" },
        ],
      },

      tableDatas: [
        {
          index: 0,
          id: "1",
          buttonadd: true,
          wastetype: "",
          nickname: "",
          swcode: "",
          swcodes: [],
          packaging: "",
          wasteorigin: "",
          wasteComponents: [
            {
              component_name: "",
            },
          ],
          estqty: "",
          estqtyy: "",
          packagingname: "",
          measurement: "kg",
          remarks: "",
          images: [],
          previewImage: [],
          // "https://www.tutorialspoint.com/assets/questions/media/426142-1668760872.png",
        },
      ],

      // packagingname: "",

      modals: {
        submit: false,
        warningsubmit: false,
        supportdoc: false,
        successModal: false,
      },
      submit: false,
    };
  },
  created() {
    this.positionid = parseInt(
      JSON.parse(atob(sessionStorage.getItem("token").split(".")[1]))
        .position_id
    );
    this.getLocation();
    this.getWasteType();
    this.getPIC();
    this.getPackaging();

    if (this.$route.params.action == "edit") {
      this.getData();
    }
    if (this.$route.params.action == "add") {
      this.displayflag = true;
    }
    if (this.$route.params.action == "view") {
      this.getData();
    }
  },
  mounted() { },
  computed: {
    canproceed() {
      return this.tableDatas.every(row => row.swcode && row.estqty >= 0 && row.estqtyy >= 0 && row.packaging);
    }
  },
  watch: {
    "selects.pic"() {
      for (var i = 0; i < this.selects.pics.length; i++) {
        if (this.selects.pic == this.selects.pics[i].value) {
          this.phoneno =
            this.selects.pics[i].phoneno == "" ||
              this.selects.pics[i].phoneno == null
              ? "N/A"
              : this.selects.pics[i].phoneno;
          this.faxno =
            this.selects.pics[i].faxno == "" ||
              this.selects.pics[i].faxno == null
              ? "N/A"
              : this.selects.pics[i].faxno;
          this.email = this.selects.pics[i].email;
        }
      }
    },

    "selects.location"() {
      console.log("read chanegs");
      this.selects.collection = "";
      this.locations();
    },

    positionid() {
      console.log(this.positionid);
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
    status() {
      console.log(this.status);
      if (this.positionid == 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid == 4 && this.status != 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status == 100) {
        this.displayflag = false;
      } else if (this.positionid != 4 && this.status != 100) {
        this.displayflag = true;
      }
    },
  },

  methods: {
    nextWithCondition() {
      this.$router.push(
        "/OutgoingJobPage/" + this.$route.params.jobnum + "/edit"
      );
      this.nextTab();
    },
    submitwastedetail() {
      const submitNotReady = [this.selects.location, this.selects.pic, this.tableDatas.length]
      if (submitNotReady.some(e => e === "" || e === 0)) {
        this.modals.warningsubmit = true;
        return
      } else if (parseInt(this.status) >= 3) {
        this.nextTab();
        return
      }

      const wasteDetail = []
      for (const data of this.tableDatas) {
        const component = data.wasteComponents.map(e => e.name)
        wasteDetail.push({
          waste_type_id: data.swcode,
          waste_component: component,
          quantity: parseInt(data.estqty),
          quantity_unit: data.measurement,
          packaging_type_id: data.packaging,
          packaging_quantity: parseInt(data.estqtyy),
          remark: data.remarks,
          for_sell: data.action,
        })
      }
      const obj = {
        service_location_id: this.selects.location,
        pic_id: this.selects.pic,
        waste_detail: wasteDetail,
      }
      this.$http
        .post(
          ":10001/api/v1/outgoing/waste/" + this.$route.params.jobnum,
          obj
        )
        .then((res) => {

          if (!res.error) {
            let response = res.message;
            console.log(response);
            this.title = "OUTGOING JOB SUCCESSFULLY CREATED";
            this.message =
              "Vendor has been notified to response to the job request";
            this.modals.generate = true;
            // this.redirect()
          }
        });

    },
    deletecomponent(tableindex, componentindex) {
      console.log(tableindex);
      console.log(componentindex);
      this.tableDatas[tableindex].wasteComponents.splice(componentindex, 1);
    },

    redirect() {
      this.$router.push("/Outgoing");
    },
    locations() {
      console.log("collections");
      this.selects.collections = [];
      this.$http
        .get(
          ":10001/api/v1/reference/service-location/" + this.selects.location
        )
        .then((res) => {
          if (!res.error) {
            let response = res.message;
            console.log(response);
            if (response.length != 0) {
              for (var i = 0; i < response.length; i++) {
                let obj = {
                  label: response[i].Name,
                  value: response[i].ServiceLocationCollectionId,
                };
                this.selects.collections.push(obj);
              }

              // this.selects.collection = this.selects.collections[0].value;
            }
          }
        });
    },

    getData() {
      this.load = true;
      this.tableDatas = [];

      this.$http
        .get(":10001/api/v1/outgoing/waste/" + this.$route.params.jobnum)
        .then((res) => {
          if (res.error) {
            console.error(res.message)
            throw new Error("fail to fetch outgoing waste content")
          }

          this.status = res.message.status.status
          this.locationname = res.message.service_location.location
          this.selects.location = res.message.service_location.service_location_id
          this.picname = res.message.assign_to_afes.user_name

          for (const wasteDetail of res.message.waste_detail) {
            let component = []
            if (Array.isArray(wasteDetail.waste_component)) {
              component = wasteDetail.waste_component.map(e => { name: e })
            }
            this.tableDatas.push({
              swcode: wasteDetail.waste_type.waste_type_id,
              swcodename: wasteDetail.waste_type.name,
              wasteComponents: component,
              estqty: wasteDetail.quantity,
              estqtyy: wasteDetail.packaging_quantity,
              packaging_quantity: wasteDetail.quantity,
              measurement: wasteDetail.quantity_unit,
              packaging: wasteDetail.packaging.name,
              remarks: wasteDetail.remark,
            })
          }
        }).catch(err => console.error(err));
    },

    prevTab() {
      // this.$router.push("/Outgoing");
      let parameter = {
        step: "2",
        direction: "blkg",
        data: [],
      };
      this.$emit("my-event", parameter);
    },
    nextTab() {
      let parameter = {
        step: "2",
        direction: "depan",
        data: [],
      };
      this.$emit("my-event", parameter);
    },

    getDeleteRow(row) {
      console.log(row);
      this.tableDatas.splice(row, 1);
      // wastetype
    },

    addRow() {
      console.log("sss");
      let obj = {
        index: this.tableDatas.length,
        id: this.tableDatas.length + 1,
        buttonadd: true,
        wastetype: "",
        swcode: "",
        swcodes: [],
        packaging: "",
        wasteorigin: "",
        wasteComponents: [
          {
            component_name: "",
          },
        ],
        estqty: "",
        estqtyy: "",
        packagingname: "",
        measurement: "kg",
        remarks: "",
        images: [],
        action: false
      };

      this.tableDatas.push(obj);
    },

    addWasteComponent(index) {
      this.tableDatas[index].wasteComponents.push({ component_name: "" });
    },
    tableRowClassName({ row, rowIndex }) {
      // console.log(rowIndex % 2);
      if (rowIndex % 2 == 0) {
        let style = { background: "#FFFFFF", color: "#15cf79" };
        return style;
      } else {
        let style = { background: "#f5f6fa", color: "#959595" };
        return style;
      }
    },
    getLocation() {
      this.selects.locations = [];
      this.$http.get(":10001/api/v1/reference/service-location").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].Location,
              value: response[i].ServiceLocationId,
            };

            this.selects.locations.push(obj);
          }

          // this.selects.location = this.selects.locations[0].value;
        }
      });
    },
    getPIC() {
      this.selects.pics = [];
      this.picdetail = [];

      this.$http.get(":10001/api/v1/self/pic").then((res) => {
        if (!res.error) {
          let response = res.message;

          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].user_name,
              value: response[i].user_id,
              id: response[i].user_id,
              name: response[i].user_name,
              phoneno: response[i].user_phone_number,
              faxno: response[i].user_fax_number,
              email: response[i].user_email,
            };

            this.selects.pics.push(obj);

            // let obj2 = {
            //   id: response[i].user_id,
            //   name: response[i].user_name,
            //   phoneno: response[i].user_phone_number,
            //   faxno: response[i].user_fax_number,
            //   email: response[i].user_email,
            // };

            // this.picdetail.push(obj2);
          }

          this.selects.pic = this.selects.pics[0].value;
        }
      });
    },
    getWasteType() {
      this.selects.wastetypes = [];
      this.$http.get(":10001/api/v1/outgoing/waste_type").then((res) => {
        if (!res.error) {
          let response = res.message;

          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].waste_type_id,
              flag: response[i].nickname,
            };

            this.selects.wastetypes.push(obj);
          }

          // for(var i=0; i<this.tableDatas.length; i++){
          //   this.tableDatas[i].swcodes = this.selects.wastetypes
          // }

          // this.selects.wastetype = this.selects.wastetypes[0].value;
        }
      });
    },

    getPackaging() {
      this.selects.packagings = [];
      this.$http.get(":10001/api/v1/reference/packaging").then((res) => {
        if (!res.error) {
          let response = res.message;
          console.log(response);

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].packaging_type_id,
            };

            this.selects.packagings.push(obj);
          }

          // this.selects.packaging = this.selects.packagings[0].value;
          this.selects.packaging = this.selects.packagings[0].value;
        }
      });
    },

    getType2(row) {
      row.packagingname = this.selects.packagings[row.packaging - 1].label;
    },
  },
};
</script>
<style scoped>
.swcode-text {
  color: #707070;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  /* Limit the number of lines to 3 */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.new-title {
  margin-top: 20px;
  color: #A5A5A5;
}

.subtitle {
  color: #A5A5A5;
  text-align: left;
  font-weight: 600;
  font-size: 18px;
  /* height: 20px; */
}

.custom-table .el-table__body td,
.custom-table .el-table__header th {
  color: #A5A5A5 !important;
}

.custom-dropdown-2 {
  width: 300px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  background: transparent;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  z-index: 9999;
}

.link {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

/* width */
::-webkit-scrollbar {
  width: 10px;
  height: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #dce9ff;
  border-radius: 15px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #5e99ff;
  border-radius: 15px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #176bfd;
}

/* Add this CSS to your stylesheet */
.custom-table .el-table__body-wrapper {
  overflow-y: scroll;
  /* Ensure there is a vertical scrollbar */
}

/* Webkit browsers (Chrome, Safari) */
.custom-table .el-table__body-wrapper::-webkit-scrollbar {
  width: 12px;
  /* Set the width of the scrollbar */
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #358dcc;
  /* Set the color of the scrollbar thumb */
  border-radius: 6px;
  /* Set the border radius of the scrollbar thumb */
}

.custom-table .el-table__body-wrapper::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* Set the color of the scrollbar track */
}

.custom-input {
  padding: 5px 5px 5px 5px;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
  outline: none;
  font-size: 16px;
  width: 100%;
}
</style>
